import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import './styles.scss';
import { domToReact, htmlToDOM } from 'html-react-parser';
import Icon from '../Icon';
import {useIntersect} from '../../Utilities/UseIntersect';

export interface IClipHTMLWrapperProps {
    /* DOM to parse */
    dom?: string;
    /** Unsafe config */
    config: {
        labelShowMore: string,
        labelShowLess: string
    };
}

export interface IClipHTMLProps {
    /* DOM to parse */
    dom: string;
    /** Unsafe config */
    config: {
        labelShowMore: string,
        labelShowLess: string
    };
}

const ClipHTML: React.FunctionComponent<IClipHTMLProps> = (props: IClipHTMLProps) => {
    const [isClipped, setIsClipped] = useState<boolean>(true);
    const [isTogglable, setIsTogglable] = useState<boolean>(false);
    const { config, dom } = props;
    const domTree = Array.isArray(dom) ? dom : htmlToDOM(dom.replace(/>\s+</g, '><'));

    const post = useIntersect({
        root: null,
        rootMargin: '0px',
        threshold: Array.from(Array(100).keys(), (i) => i / 100),
    });



    // Watch side intersections

    useEffect(() => {
        if (post.entry) {
            if (post.entry.intersectionRatio > 0) {
                setIsTogglable(false);
            } else {
                setIsTogglable(true);
            }
        }
    }, [post.entry]);

    return (
        <div className={classNames('clipped-content', {'is-clipped': isClipped})}>
            <div className="clipped-content__inner">
                {domToReact(domTree, {})}
            </div>
            {isTogglable && (
                <button
                    className="clipped-content__toggler"
                    onClick={() => { setIsClipped(!isClipped);}}
                    aria-label={isClipped ? config.labelShowMore : config.labelShowLess}
                >
                    <span><Icon kind={isClipped ? 'arrow1-down' : 'arrow1-up'} width={16} height={16}/></span>
                </button>
            )}
            <div style={{ height: '1px', width: '100%', backgroundColor: 'transparent', position: 'relative', zIndex: 10, top: isClipped ? '0' : '1px', }} ref={post.node}/>
        </div>
    );
};

ClipHTML.displayName = 'ClipHTML';

const ClipHtmlWrapper: React.FunctionComponent<IClipHTMLWrapperProps> = (props) => {
    if (!props.dom) {
        return null;
    }
    return (<ClipHTML dom={props.dom} config={props.config}/>);
};

export default ClipHtmlWrapper;
